module.exports = __webpack_public_path__ + "img/device.f411d7ed.png";